import { Form, Formik, FormikValues } from 'formik';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import FormikButton from '../../../common/formik/FormikButton';
import FormikGrid from '../../../common/formik/FormikGrid';
import FormikTextField from '../../../common/formik/FormikTextField';
import { Training } from '../Training.interface';
import { useCreateTraining } from '../Training.hooks';

export interface TrainingCreateDialogProps {
  open: boolean;
  onCancel?: () => void;
  onCreated?: (training: Training) => void;
}

const TrainingCreateDialog: React.FC<TrainingCreateDialogProps> = ({
  open,
  onCancel,
  onCreated
}) => {
  const formikRef = useRef<FormikValues>();
  const { training, isLoading, error, post } = useCreateTraining();
  useEffect(() => {
    if (!isLoading) {
      if (onCreated && training) {
        onCreated(training);
      }
      if (formikRef && formikRef.current) {
        formikRef.current.setSubmitting(false);
      }
    }
  }, [isLoading, onCreated, training]);
  return (
    <Dialog open={open} onClose={onCancel}>
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ name: '' }}
        validationSchema={Yup.object({
          name: Yup.string().required('Required')
        })}
        onSubmit={(trainingDto: Partial<Training>) => {
          post(trainingDto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>New Training</DialogTitle>
          <DialogContent>
            <DialogContentText>
              What is the name of the training?
            </DialogContentText>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='name'
                label='Training Name'
              />
            </FormikGrid>
            {error && (
              <Alert severity='error'>
                Error occurred. Please check your internet connection and try
                again.
              </Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Create</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default TrainingCreateDialog;
